"use client";
import React from "react";
import { faqsData } from "@/data/faqs.data";
import { Faq } from "@/components/faq/Faq";
import SectionHeader from "@/components/shared/headers/SectionHeader";
import { TransitionLink } from "@/components/shared/TransitionLink";
import { useDict } from "@/components/providers/LocaleProvider";

export default function FaqSection() {
  const t = useDict();
  const firstCategory = faqsData[0];
  const categoryDict = t.faqPage.categories[firstCategory.key];

  return (
    <>
      <SectionHeader
        title={t.home.faq.title}
        description={t.home.faq.description}
      />

      <section className="space-y-4">
        {firstCategory.questionKeys.map((qkey) => {
          const qa = (
            categoryDict.questions as Record<string, { q: string; a: string }>
          )[qkey];
          if (!qa) return null;
          return <Faq key={qkey} faq={{ qns: qa.q, ans: qa.a }} />;
        })}
      </section>
      <section className=" py-4 mt-8 w-full flex justify-center items-center">
        <TransitionLink
          href={"/faq"}
          className=" place-self-center bg-primary/80 text-white rounded-full px-6 py-3 hover:scale-105 transition duration-500 ease-in-out cursor-pointer shadow-[0_0_15px_#846dff]"
        >
          {t.home.faq.viewAll}
        </TransitionLink>
      </section>
    </>
  );
}
